import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-antar-rekening',
  templateUrl: './antar-rekening.component.html',
  styleUrls: ['./antar-rekening.component.sass']
})
export class AntarRekeningComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
